import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Grid from "@mui/material/Grid";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
  border: "none !important",
};

export default function DeleteModal({ setOpenDeleteModal, openDeleteModal, deleteData, setshowBranch, data }) {
  const [errorMessage, setErrorMessage] = React.useState("");

  const handleClose = () => {
    setOpenDeleteModal(false);
    setErrorMessage(""); 
  };

  React.useEffect(()=>{
    if (Array.isArray(data?.children) && data?.children?.length > 0)  {
      setErrorMessage("This organization cannot be deleted because it has sub-companies or branches.");
    }

  },[data])


  const handleDelete = () => {
   
    if (data?.children
      && data.children.length > 0) {
      setErrorMessage("This organization cannot be deleted because it has sub-companies or branches.");
    } else {
      setshowBranch(false);
      deleteData();
      handleClose();
    }
  };
  return (
    <div>
      <Modal
        open={openDeleteModal}
        onClose={handleClose}
        aria-labelledby="modal-delete-title"
        aria-describedby="modal-delete-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-delete-title"
            variant="h5"
            component="h2"
            sx={{ mb: 2, textAlign: "center" }}
          >
            Delete
          </Typography>

          {/* Show a warning message if there are sub-companies or branches */}
          {errorMessage ? (
            <Typography
              id="modal-error-message"
              sx={{ mt: 2, mb: 3, color: "red", textAlign: "center" }}
            >
              {errorMessage}
            </Typography>
          ) : (
            <Typography
              id="modal-delete-description"
              sx={{ mt: 2, mb: 3, textAlign: "center" }}
            >
              Are you sure you want to delete the organization?
            </Typography>
          )}
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
                sx={{ minWidth: "100px" }}
                disabled={errorMessage!==""?true:false}
              >
                Delete
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleClose}
                sx={{ minWidth: "100px" }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
